<style scoped lang="less">
@import 'modal.less';

.modal-item {
  .modal-item-base();
}

.phone-modal-base();
</style>

<template>
  <!-- 修改手机号模态框 - 开始 -->
  <Modal
    v-model="vis"
    :mask-closable="false"
    :loading="true"
    :title="$t('修改手机号')"
  >
    <div class="modal-item country-and-phone">
      <div class="modal-item-country">
        <h4>{{ $t('国家') }}</h4>
        <Select
          v-model="areaCode"
          class="country-select"
          size="large"
          style="width: 98px"
        >
          <Option
            v-for="item in countryList"
            :value="item.areaCode"
            :key="item.id"
            >{{ item.zhName }}</Option
          >
        </Select>
      </div>

      <div class="modal-item-phone">
        <h3>{{ $t('新手机号') }}</h3>
        <input type="text" v-model="newPhone" />
      </div>
    </div>

    <div class="modal-item">
      <h3>{{ $t('新短信验证码') }}</h3>
      <div class="verify-code-box">
        <input type="text" v-model="code.newPhone" />
        <verify-code
          class="verify-code"
          @click="sendNewPhoneSms"
          :rebase="vis"
        ></verify-code>
      </div>
    </div>

    <div
      class="modal-item"
      v-if="userInfo.emailStatus && userInfo.enableEmailCheck"
    >
      <h3>{{ $t('邮箱验证码') }}</h3>
      <div class="verify-code-box">
        <input type="text" v-model="code.email" />
        <verify-code
          class="verify-code"
          @click="sendEmailSms"
          :rebase="vis"
        ></verify-code>
      </div>
      <div class="warn-tips">
        {{ $t('输入邮箱') }} {{ userInfo.email | strEncrypt }}
        {{ $t('收到的验证码') }}
      </div>
    </div>

    <div class="modal-item">
      <h3>{{ $t('旧短信验证码') }}</h3>
      <div class="verify-code-box">
        <input type="text" v-model="code.oldPhone" />
        <verify-code class="verify-code" @click="sendOldPhoneSms"></verify-code>
      </div>
      <div class="warn-tips">
        {{ $t('输入手机') }} {{ userInfo.mobilePhone | strEncrypt }}
        {{ $t('收到的验证码') }}
      </div>
    </div>

    <div
      class="modal-item"
      v-if="userInfo.googleStatus && userInfo.enableGoogleCheck"
    >
      <h3>{{ $t('谷歌验证码') }}</h3>
      <input type="text" v-model="code.google" />
    </div>
    <template #footer>
      <el-button @click="vis = false">{{ $t('取消') }}</el-button>
      <el-button
        type="primary"
        :loading="btnLoading.confirm"
        @click="confirmModifyPhone"
        >{{ $t('确定') }}</el-button
      >
    </template>
  </Modal>
  <!-- 修改手机号模态框 - 结束 -->
</template>

<script>
import ModalBase from '@/components/ModalBase'
import {
  ajaxSmsHandle,
  ajaxTry,
  ajaxDataShrink,
  ajaxTip,
  ajaxAlert,
  updateUserInfo
} from '@/utils'
import {
  ajax_getContry,
  ajax_sendEmailSms,
  ajax_sendSms,
  ajax_modifyPhone
} from '@/api/personal'
import { mapState } from 'vuex'

export default {
  name: 'ModifyPhoneModal',
  extends: ModalBase,
  data() {
    return {
      areaCode: 86,
      countryList: [],
      newPhone: '',
      code: {
        newPhone: '',
        oldPhone: '',
        email: '',
        google: ''
      }
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  async created() {
    let [flag, res] = await ajaxTry(ajax_getContry()).then(ajaxDataShrink)
    if (flag) this.countryList = res.data
  },
  methods: {
    sendNewPhoneSms($event) {
      // 发送新手机号的验证码
      let ajaxParam = {
        phone: this.newPhone,
        areaCode: this.areaCode,
        smstype: 8
      }
      ajaxSmsHandle(ajax_sendSms(ajaxParam), $event).then(ajaxTip)
    },
    sendEmailSms($event) {
      let ajaxParam = {
        email: this.userInfo.email,
        smstype: 8
      }
      // 发送邮箱的验证码
      ajaxSmsHandle(ajax_sendEmailSms(ajaxParam), $event).then(ajaxTip)
    },
    sendOldPhoneSms($event) {
      let ajaxParam = {
        phone: this.userInfo.mobilePhone,
        areaCode: 86,
        smstype: 8
      }
      // 发送旧的短信验证码
      ajaxSmsHandle(ajax_sendSms(ajaxParam), $event).then(ajaxTip)
    },
    async confirmModifyPhone() {
      let ajaxParam = {
        phone: this.newPhone,
        areaCode: 86,
        oldSmsCode: this.code.oldPhone,
        newSmsCode: this.code.newPhone,
        emailCode: this.code.email,
        googleCode: this.code.google
      }
      // 确认修改手机号
      this.btnLoading.confirm = true
      let [flag] = await ajaxTry(ajax_modifyPhone(ajaxParam))
        .then(ajaxAlert)
        .then(updateUserInfo)
      this.btnLoading.confirm = false
      if (flag) this.vis = false
    }
  }
}
</script>
